module.exports = __webpack_public_path__ + "img/magento-migration.65a66fac.jpg";